import { createSlice } from '@reduxjs/toolkit';
import { replaceRealtimeSections, clearJobDetails } from './jobDetailsSlice';
import { jobSectionMap } from '../jobSectionMap';
import { computeSectionTbdState } from '../jobSectionState';

// Initial state for tracking TBD status for multiple forms
const initialState = {
  forms: {},
  auditItems: [],
  fullJobAuditItems: [],
  selectedItem: null,
};

// Create the slice
const tbdSlice = createSlice({
  name: 'tbd',
  initialState,
  extraReducers: builder => {
    builder.addCase(replaceRealtimeSections, (state, action) => {
      if (Array.isArray(action.payload.tbdAudit)) {
        state.auditItems = action.payload.tbdAudit;
        state.fullJobAuditItems = action.payload.tbdAudit;
      }
      Object.values(jobSectionMap).forEach(section => {
        if (Array.isArray(action.payload[section])) {
          state.forms[section] = computeSectionTbdState(action.payload[section]);
        }
      });
    }).addCase(clearJobDetails, state => {
      state.fullJobAuditItems = [];
      state.auditItems = [];
      state.selectedItem = null;
    });
  },
  reducers: {
    setFullJobTbdAuditItems: (state, action) => {
      state.fullJobAuditItems = Array.isArray(action.payload) ? action.payload : [];
      state.auditItems = state.fullJobAuditItems;
    },
    // Replace TBDAudit-backed TBD rows for the active job payload
    setTbdAuditItems: (state, action) => {
      state.auditItems = Array.isArray(action.payload) ? action.payload : [];
    },

    // Replace all form TBD state in one update (used by full job hydration)
    setAllTbdForms: (state, action) => {
      state.forms = action.payload || {};
    },

    // Action to update TBD fields for a specific form
    updateTbdFields: (state, action) => {
      const { formName, tbdFields, hasTbd } = action.payload;
      state.forms[formName] = { tbdFields, hasTbd };
    },

    // Optional action to clear TBD fields for a specific form
    clearTbdFields: (state, action) => {
      const { formName } = action.payload;
      delete state.forms[formName];
    },

    // Action to set selected item
    setSelectedItem: (state, action) => {
      state.selectedItem = action.payload;
    },
  },
});

// Export the actions
export const { setFullJobTbdAuditItems, setTbdAuditItems, setAllTbdForms, updateTbdFields, clearTbdFields, setSelectedItem } = tbdSlice.actions;

// Export the reducer to be included in the store
export default tbdSlice.reducer;
